module.exports = __webpack_public_path__ + "img/investment.7265298f.png";